import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { FORM_ELEMENT_IDS } from "@/features/LiveFormEditor/Steps/helpers/formStepToElementIdMap";
import { LabeledFormDate, LabeledFormDateProps } from "@/forms-design-system/FormDate";
type AuctionCampaignDateProps = Omit<LabeledFormDateProps, "id" | "title" | "data-test">;

export const AuctionCampaignDate: FC<AuctionCampaignDateProps> = ({ ...rest }) => {
  const { t } = useTranslate();

  return (
    <LabeledFormDate
      id={FORM_ELEMENT_IDS["date"]}
      title={t("ticketing", "dateSummary.auctionClosing")}
      data-test="ticketing-date-summary"
      {...rest}
    />
  );
};
